import axios from 'axios';
import { SERVER_URL } from '../App';

/**
 * @param {object} state generator export object (build, buildName, genConfig, activeMenu, …)
 * @returns {Promise<string>} slug
 */
export async function createShare(state) {
    const base = SERVER_URL();
    const { data } = await axios.post(`${base}share/`, { state }, {
        headers: { 'Content-Type': 'application/json' },
    });
    if (!data?.slug) throw new Error('missing slug');
    return data.slug;
}

/**
 * @param {string} slug
 * @returns {Promise<object>} state
 */
export async function fetchShare(slug) {
    const base = SERVER_URL();
    const { data } = await axios.get(`${base}share/${encodeURIComponent(slug)}/`);
    if (!data?.state) throw new Error('missing state');
    return data.state;
}
